import * as Sentry from '@sentry/browser';

/**
 * Initializes browser error reporting.
 */
export function initSentry(): void {
  if (__PRODUCTION__) {
    Sentry.init({
      dsn: __SENTRY_DSN__,
      integrations: [],
      // v11 collects PII by default; keep v10's restrictive behavior
      dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: {
          request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
          response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        },
        httpBodies: [],
        urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      },
    });
  } else {
    console.warn('using dev project credentials');
  }
}

/**
 * Captures a handled error in production.
 */
export function captureException(error: unknown): void {
  if (__PRODUCTION__) {
    Sentry.captureException(error);
  }
}
